<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="grey darken-1">
        <strong class="subheading">Get connected with us on social networks!</strong>
        <v-spacer></v-spacer>
        <!-- <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-3"
          dark
          icon
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn> -->
        <a href="https://www.facebook.com/eWak.Cloud.Ltd" target="_blank" class="mx-3">
          <img src="@/assets/fb.png" class="icons">
        </a>
        <a href="https://twitter.com/Ewak_Cloud_Ltd" target="_blank" class="mx-3">
          <img src="@/assets/twitter.png" class="icons">
        </a>
        <a href="https://www.instagram.com/ewak.cloud.ltd/" target="_blank" class="mx-3">
          <img src="@/assets/instagram.png" class="icons">
        </a>
        <a :href="`https://wa.me/254777221441`" class="mx-3" target="_blank">
        <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
        </a>
        <a :href="`https://www.youtube.com/channel/UC0njxYuYC3i3KvEVGiJSfeg`" target="_blank">
          <img src="@/assets/youtube.png" style="width: 40px; height: 40px;" alt="">
          </a>
        <v-spacer></v-spacer>
        <strong class="subheading">Contact Support: <span class="hidden-sm-and-down" style="color: #03a9f4">+254777221441</span><a class="hidden-md-and-up pl-2" href="tel:+254777221441">+254777221441</a> | <a href="mailto:ewakcloudltd@gmail.com">ewakcloudltd@gmail.com</a></strong>
      </v-card-title>

      <v-card-actions class="grey darken-3 justify-center">
        &copy;2024 — <strong>Ewak</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>


<script>
export default {
  data: () => ({
    icons: [
      "facebook",
      "fab fa-twitter",
      "fab fa-google-plus",
      "fab fa-linkedin",
      "fab fa-instagram"
    ]
  })
};
</script>

<style scoped>
.icons {
  width: 30px; 
  height: 30px;
}
</style>
